// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Root layout */
.admin-layout {
  display: grid;
  position: relative;
  gap: 24px;
  height: 100%;
  background: #f5f7fb; /* light app background */
  overflow: hidden; /* Contain the drawer */
  /* Layout variables for aligning fixed footer with main content */
  /* --sidebar-width: 320px;
  --layout-gap: 24px;
  --main-padding-x: 24px; */
}

/* Sidebar */
.sidebar {
  background: #f5f7fb;
  padding: 20px 16px 24px;
  border-right: 1px solid #e5e7eb;
  position: sticky;
  top: 0;
  height: 100vh;
  overflow: hidden;
}

/* Menu */
.menu {
  height: 100%;
  display: flex;
  flex-direction: column;
  color: #475569;
}

.menu-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 18px;
  color: #0f172a;
  margin: 4px 0;
}

.menu-subtitle {
  font-size: 12px;
  color: #64748b;
  margin-bottom: 16px;
}

.menu-list {
  overflow: auto;
  padding-right: 6px; /* room for scrollbar */
  display: grid;
  gap: 12px;
}

.menu-item {
  display: grid;
  grid-template-columns: 40px 1fr;
  gap: 12px;
  padding: 12px;
  border-radius: 12px;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  text-align: left;
  cursor: pointer;
  transition: background 0.2s, border-color 0.2s, transform 0.05s;
}

.menu-item:hover {
  border-color: #cbd5e1;
  background: #f8fafc;
}
.menu-item:active {
  transform: translateY(1px);
}

.menu-item.selected {
  border-color: #2563eb;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.15) inset;
}
.menu-item.disabled {
  opacity: 0.8;
  cursor: not-allowed;
}

.menu-item-icon {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: #f1f5f9;
  display: grid;
  place-items: center;
  font-size: 20px;
}

.menu-item-header {
  display: flex;
  align-items: center;
  gap: 10px;
}
.menu-item-title {
  color: #0f172a;
  font-weight: 600;
}
.menu-item-desc {
  color: #64748b;
  font-size: 12px;
  margin-top: 2px;
}

.status-pill {
  font-size: 11px;
  padding: 2px 8px;
  border-radius: 999px;
  border: 1px solid transparent;
}
.status-pill.active {
  color: #065f46;
  background: rgba(16, 185, 129, 0.15);
  border-color: rgba(5, 150, 105, 0.25);
}
.status-pill.soon {
  color: #475569;
  background: rgba(148, 163, 184, 0.15);
  border-color: rgba(148, 163, 184, 0.3);
}
.status-pill.small {
  font-size: 12px;
  padding: 4px 8px;
}

.menu-ext {
  margin-top: auto;
  border-top: 1px solid #e5e7eb;
  padding-top: 12px;
}
.menu-ext h4 {
  color: #0f172a;
  margin: 8px 0;
}
.menu-ext p {
  color: #64748b;
  font-size: 12px;
}

/* Main content */
.admin-main {
  background: #ffffff;
  padding: 20px 24px 40px;
  display: flex;
  flex-direction: column;
  min-height: 0; /* for children flex sizing */
  padding-bottom: 90px; /* space for fixed pagination */
}

.admin-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 8px 0 16px;
  margin-top: 10px;
}

.page-title {
  color: #111827;
  margin: 0;
  font-size: 24px;
}
.page-subtitle {
  color: #6b7280;
  margin: 4px 0 0 0;
  font-size: 14px;
}

.primary-btn {
  background: #2563eb;
  color: #fff;
  border: none;
  padding: 10px 14px;
  border-radius: 10px;
  font-weight: 600;
  cursor: pointer;
}
.primary-btn:hover {
  background: #1d4ed8;
}

/* Stats grid */
.subheader-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px;
  margin-bottom: 8px;
}

.stat-card {
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 16px;
}

.stat-label {
  color: #6b7280;
  font-size: 12px;
}
.stat-value-row {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 6px;
}
.stat-value {
  color: #0f172a;
  font-size: 28px;
  font-weight: 700;
}

/* Content section */
.content-card {
  margin-top: 20px;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 16px;
}
.content-card.fill {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.section-title {
  color: #111827;
  margin: 0 0 12px;
  font-size: 16px;
}
.content-placeholder {
  color: #6b7280;
  font-size: 14px;
}

/* Let the last content card grow to fill remaining space */
.admin-main > .content-card.fill {
  flex: 1 1;
  overflow: hidden; /* grid will manage its own scrolling */
}
.menu-btn {
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  cursor: pointer;
  border: 1px solid #e5e7eb;
  background: #ffffff;
  transition: background-color 0.2s;
  flex-shrink: 0;
}

.menu-btn:hover {
  background: #f8fafc;
}
/* Fixed footer aligned with main content width */
.fixed-footer {
  position: fixed;
  bottom: 0;
  left: calc(var(--sidebar-width) + var(--layout-gap) + var(--main-padding-x));
  right: var(--main-padding-x);
  height: 50px;
  background-color: #fff;
  z-index: 1000;
  box-shadow: 0px -2px 4px rgba(0, 0, 0, 0.05);
  padding: 0 16px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

/* Responsive */
@media (max-width: 1024px) {
  .admin-layout {
    grid-template-columns: 280px 1fr;
    --sidebar-width: 280px;
  }
}

@media (max-width: 768px) {
  .admin-layout {
    grid-template-columns: 1fr;
    --sidebar-width: 0px;
    --layout-gap: 0px;
  }
  .sidebar {
    position: relative;
    height: auto;
    border-right: none;
    border-bottom: 1px solid #e5e7eb;
  }
  .menu-list {
    max-height: 280px;
  }
  .admin-header {
    flex-direction: column;
    align-items: flex-start;
  }
  .subheader-grid {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/admin-screen/Admin.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;EACE,aAAa;EACb,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,mBAAmB,EAAE,yBAAyB;EAC9C,gBAAgB,EAAE,uBAAuB;EACzC,iEAAiE;EACjE;;2BAEyB;AAC3B;;AAEA,YAAY;AACZ;EACE,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,gBAAgB;EAChB,MAAM;EACN,aAAa;EACb,gBAAgB;AAClB;;AAEA,SAAS;AACT;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,aAAa;AACf;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB,EAAE,uBAAuB;EAC3C,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,+DAA+D;AACjE;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,mDAAmD;AACrD;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,6BAA6B;AAC/B;AACA;EACE,cAAc;EACd,oCAAoC;EACpC,qCAAqC;AACvC;AACA;EACE,cAAc;EACd,qCAAqC;EACrC,sCAAsC;AACxC;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,aAAa;AACf;AACA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,aAAa,EAAE,6BAA6B;EAC5C,oBAAoB,EAAE,+BAA+B;AACvD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,SAAS;EACT,eAAe;AACjB;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,2DAA2D;AAC3D;EACE,SAAO;EACP,gBAAgB,EAAE,uCAAuC;AAC3D;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;AACA,iDAAiD;AACjD;EACE,eAAe;EACf,SAAS;EACT,4EAA4E;EAC5E,4BAA4B;EAC5B,YAAY;EACZ,sBAAsB;EACtB,aAAa;EACb,4CAA4C;EAC5C,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA,eAAe;AACf;EACE;IACE,gCAAgC;IAChC,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,oBAAoB;IACpB,iBAAiB;EACnB;EACA;IACE,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,gCAAgC;EAClC;EACA;IACE,iBAAiB;EACnB;EACA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":["/* Root layout */\n.admin-layout {\n  display: grid;\n  position: relative;\n  gap: 24px;\n  height: 100%;\n  background: #f5f7fb; /* light app background */\n  overflow: hidden; /* Contain the drawer */\n  /* Layout variables for aligning fixed footer with main content */\n  /* --sidebar-width: 320px;\n  --layout-gap: 24px;\n  --main-padding-x: 24px; */\n}\n\n/* Sidebar */\n.sidebar {\n  background: #f5f7fb;\n  padding: 20px 16px 24px;\n  border-right: 1px solid #e5e7eb;\n  position: sticky;\n  top: 0;\n  height: 100vh;\n  overflow: hidden;\n}\n\n/* Menu */\n.menu {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  color: #475569;\n}\n\n.menu-title {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 18px;\n  color: #0f172a;\n  margin: 4px 0;\n}\n\n.menu-subtitle {\n  font-size: 12px;\n  color: #64748b;\n  margin-bottom: 16px;\n}\n\n.menu-list {\n  overflow: auto;\n  padding-right: 6px; /* room for scrollbar */\n  display: grid;\n  gap: 12px;\n}\n\n.menu-item {\n  display: grid;\n  grid-template-columns: 40px 1fr;\n  gap: 12px;\n  padding: 12px;\n  border-radius: 12px;\n  background: #ffffff;\n  border: 1px solid #e5e7eb;\n  text-align: left;\n  cursor: pointer;\n  transition: background 0.2s, border-color 0.2s, transform 0.05s;\n}\n\n.menu-item:hover {\n  border-color: #cbd5e1;\n  background: #f8fafc;\n}\n.menu-item:active {\n  transform: translateY(1px);\n}\n\n.menu-item.selected {\n  border-color: #2563eb;\n  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.15) inset;\n}\n.menu-item.disabled {\n  opacity: 0.8;\n  cursor: not-allowed;\n}\n\n.menu-item-icon {\n  width: 40px;\n  height: 40px;\n  border-radius: 10px;\n  background: #f1f5f9;\n  display: grid;\n  place-items: center;\n  font-size: 20px;\n}\n\n.menu-item-header {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n.menu-item-title {\n  color: #0f172a;\n  font-weight: 600;\n}\n.menu-item-desc {\n  color: #64748b;\n  font-size: 12px;\n  margin-top: 2px;\n}\n\n.status-pill {\n  font-size: 11px;\n  padding: 2px 8px;\n  border-radius: 999px;\n  border: 1px solid transparent;\n}\n.status-pill.active {\n  color: #065f46;\n  background: rgba(16, 185, 129, 0.15);\n  border-color: rgba(5, 150, 105, 0.25);\n}\n.status-pill.soon {\n  color: #475569;\n  background: rgba(148, 163, 184, 0.15);\n  border-color: rgba(148, 163, 184, 0.3);\n}\n.status-pill.small {\n  font-size: 12px;\n  padding: 4px 8px;\n}\n\n.menu-ext {\n  margin-top: auto;\n  border-top: 1px solid #e5e7eb;\n  padding-top: 12px;\n}\n.menu-ext h4 {\n  color: #0f172a;\n  margin: 8px 0;\n}\n.menu-ext p {\n  color: #64748b;\n  font-size: 12px;\n}\n\n/* Main content */\n.admin-main {\n  background: #ffffff;\n  padding: 20px 24px 40px;\n  display: flex;\n  flex-direction: column;\n  min-height: 0; /* for children flex sizing */\n  padding-bottom: 90px; /* space for fixed pagination */\n}\n\n.admin-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 8px 0 16px;\n  margin-top: 10px;\n}\n\n.page-title {\n  color: #111827;\n  margin: 0;\n  font-size: 24px;\n}\n.page-subtitle {\n  color: #6b7280;\n  margin: 4px 0 0 0;\n  font-size: 14px;\n}\n\n.primary-btn {\n  background: #2563eb;\n  color: #fff;\n  border: none;\n  padding: 10px 14px;\n  border-radius: 10px;\n  font-weight: 600;\n  cursor: pointer;\n}\n.primary-btn:hover {\n  background: #1d4ed8;\n}\n\n/* Stats grid */\n.subheader-grid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 16px;\n  margin-bottom: 8px;\n}\n\n.stat-card {\n  background: #ffffff;\n  border: 1px solid #e5e7eb;\n  border-radius: 12px;\n  padding: 16px;\n}\n\n.stat-label {\n  color: #6b7280;\n  font-size: 12px;\n}\n.stat-value-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-top: 6px;\n}\n.stat-value {\n  color: #0f172a;\n  font-size: 28px;\n  font-weight: 700;\n}\n\n/* Content section */\n.content-card {\n  margin-top: 20px;\n  background: #ffffff;\n  border: 1px solid #e5e7eb;\n  border-radius: 12px;\n  padding: 16px;\n}\n.content-card.fill {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n.section-title {\n  color: #111827;\n  margin: 0 0 12px;\n  font-size: 16px;\n}\n.content-placeholder {\n  color: #6b7280;\n  font-size: 14px;\n}\n\n/* Let the last content card grow to fill remaining space */\n.admin-main > .content-card.fill {\n  flex: 1;\n  overflow: hidden; /* grid will manage its own scrolling */\n}\n.menu-btn {\n  width: 48px;\n  height: 48px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 8px;\n  cursor: pointer;\n  border: 1px solid #e5e7eb;\n  background: #ffffff;\n  transition: background-color 0.2s;\n  flex-shrink: 0;\n}\n\n.menu-btn:hover {\n  background: #f8fafc;\n}\n/* Fixed footer aligned with main content width */\n.fixed-footer {\n  position: fixed;\n  bottom: 0;\n  left: calc(var(--sidebar-width) + var(--layout-gap) + var(--main-padding-x));\n  right: var(--main-padding-x);\n  height: 50px;\n  background-color: #fff;\n  z-index: 1000;\n  box-shadow: 0px -2px 4px rgba(0, 0, 0, 0.05);\n  padding: 0 16px;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n}\n\n/* Responsive */\n@media (max-width: 1024px) {\n  .admin-layout {\n    grid-template-columns: 280px 1fr;\n    --sidebar-width: 280px;\n  }\n}\n\n@media (max-width: 768px) {\n  .admin-layout {\n    grid-template-columns: 1fr;\n    --sidebar-width: 0px;\n    --layout-gap: 0px;\n  }\n  .sidebar {\n    position: relative;\n    height: auto;\n    border-right: none;\n    border-bottom: 1px solid #e5e7eb;\n  }\n  .menu-list {\n    max-height: 280px;\n  }\n  .admin-header {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n  .subheader-grid {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
